// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderList_container__3xu65"};